import { gql } from '@apollo/client';


export const LAUNCHES_QUERY = gql`
    query LaunchesQuery {
        launches {
            id
            launchpad
            flight_number
            name
            date_utc
            date_local
            success
            details
            rocket
        }
    }
`;

export const LAUNCH_QUERY = gql`
    query Launch($launchId: String!) {
        launch(id: $launchId) {
            id
            flight_number
            name
            date_local
            success
            details
            rocket
            failures {
                time
                altitude
                reason
            }
            links {
                patch { small }
                webcast
                presskit
                article
                wikipedia
            }
        }
        rockets {
            id
            name
            country
            company
            first_flight
            flickr_images
            type
        }  
    }
`;

export const ROCKETS_QUERY = gql`
    query RocketsQuery {
        rockets {
            id
            name
            type
            active
            stages
            boosters
            cost_per_launch
            suucess_rate_pct
            first_flight
            country
            company
            wikipedia
            desciption
            flickr_images
        }
    }
`;

export const ROCKET_QUERY = gql`
    query RocketQuery($rocketId: String!) {
        rocket(id: $rocketId) {
            id
            name
            type
            stages
            boosters
            flickr_images
            cost_per_launch
            success_rate_pct
            first_flight
            country
            company
            wikipedia
            description
        }
    }
`;
